import Dataman from 'App/Dataman';
import { sortAsc } from 'App/utils/Helpers';
import modules from 'App/utils/Modules';
import { CAT_RESEARCHES } from 'App/utils/Collections';
import { i18n } from 'App/plugins/i18n';

export function SPDomainsLoader() {
  return Dataman.DB.researchesDomains
    .getList({
      'order[name]': 'asc',
      properties: ['id', 'name'],
      itemsPerPage: 400,
      ...this.filter,
    })
    .then((res) => {
      return res.data['hydra:member'].sort(() => sortAsc('name')).map((el) => ({ text: el.name, value: el.id }));
    });
}

export function searchSPDomains(term) {
  return Dataman.DB.researchesDomains
    .getList({
      'order[name]': 'asc',
      name: term,
      relevantOrder: 'name',
    })
    .then((res) => {
      return res.data['hydra:member'].sort(() => sortAsc('name')).map((el) => ({ text: el.name, value: el.id }));
    });
}

export function SPAuthorsLoader() {
  return Dataman.DB.researchesAuthors
    .getList({
      properties: ['id', 'name'],
      itemsPerPage: 400,
      'order[name]': 'asc',
      ...this.filter,
    })
    .then((res) => {
      return res.data['hydra:member'].sort(() => sortAsc('name')).map((el) => ({ text: el.name, value: el.id }));
    });
}

export function searchSPAuthors(term, ids) {
  return Dataman.DB.researchesAuthors
    .getList({
      'order[name]': 'asc',
      name: term,
      relevantOrder: 'name',
      itemsPerPage: 200,
      id: ids,
    })
    .then((res) => {
      return res.data['hydra:member'].sort(() => sortAsc('name')).map((el) => ({ text: el.name, value: el.id }));
    });
}

function getCategoryName(name) {
  let nameParts = name.split('/');
  return nameParts[nameParts.length - 1];
}

export function SPCategoriesLoader(term) {
  return Dataman.DB.researchesCategories
    .getList({
      properties: ['id', 'name'],
      name: term,
      itemsPerPage: 200,
      'order[name]': 'asc',
      ...this.filter,
    })
    .then((res) => {
      return res.data['hydra:member']
        .sort(() => sortAsc('name'))
        .map((el) => ({ text: getCategoryName(el.name), value: el.id }));
    });
}

export function searchSPCategories(term) {
  return Dataman.DB.researchesAuthors
    .getList({
      'order[name]': 'asc',
      name: term,
      relevantOrder: 'name',
      itemsPerPage: 200,
    })
    .then((res) => {
      return res.data['hydra:member']
        .sort(() => sortAsc('name'))
        .map((el) => ({ text: getCategoryName(el.name), value: el.id }));
    });
}

export function loadResearchTypes() {
  return Dataman.Filter.getProductTypes({
    modules: modules[CAT_RESEARCHES],
    itemsPerPage: 200,
    locale: i18n.locale,
  })
    .then((res) => res.data.sort(() => sortAsc('name')))
    .catch(console.error);
}

export default {
  searchSPDomains,
  SPDomainsLoader,
  searchSPAuthors,
  SPAuthorsLoader,
  searchSPCategories,
  SPCategoriesLoader,
  loadResearchTypes,
};
